import {
  FileSpreadsheet,
  FileText,
  Image as ImageIcon,
  Paperclip,
  Presentation,
} from "lucide-react";

/**
 * Cỡ tệp đọc được: B / KB / MB.
 *
 * Trước đây luôn quy ra KB, nên một tệp 8 MB hiện là "8192 KB" — con số đúng mà
 * không ai đọc ra được là to hay nhỏ.
 */
export function formatFileSize(bytes: number | null | undefined): string {
  if (bytes == null || bytes < 0) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/**
 * Biểu tượng theo loại tệp.
 *
 * Danh sách 10 tệp mà tất cả cùng một biểu tượng thì biểu tượng không mang tin
 * gì; người dùng phải đọc từng tên tệp để biết cái nào là bảng tính.
 */
export function fileIconFor(mimeType: string | null | undefined) {
  const m = mimeType ?? "";
  if (m.startsWith("image/")) return ImageIcon;
  if (m.includes("spreadsheet") || m.includes("excel")) return FileSpreadsheet;
  if (m.includes("presentation") || m.includes("powerpoint")) return Presentation;
  if (m === "application/pdf" || m.includes("word")) return FileText;
  return Paperclip;
}
